import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { ALL_SERVICES, CEHAS_ACCESS_ACCOUNT, COMMON_MODULES, FORGOT_PASSWORD_PATH, IMAGES_URL, LOGIN, LOGIN_PATH, PLUS_MEMBERSHIP } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as faqsJson from '@src/assets/i18n/mini-env/cehas/en.json';

@Component({
  selector: 'app-cehas',
  imports: [
        ...COMMON_MODULES,
        HeadingBlockOneModule,
        IconboxOneModule,
        IconboxTwoModule,
        HeadingBlockFullWidthModule,
        ImageboxOneModule,
        ImageboxFullwidthModule,
        CardboxOneModule,
        BannerOneModule,
        ImageboxBulletScrollComponent,
        MiniEnvHeadingBlockComponent,
        MiniEnvFaqsComponent,
        MiniEnvBannerComponent,
        MembershipPlanModule,
        VideoPlayerComponent,
        MiniEnvContentBoxComponent,
  ],
  templateUrl: './cehas.component.html',
  styleUrl: './cehas.component.scss'
})
export class CehasComponent extends CoreClass implements OnInit {
IMAGES_URL: string = IMAGES_URL;
  faqList = faqsJson.FAQS.FAQ_LIST;
  imgSrc = 'assets/tenant-assets/mini-env/images/people-in-kitchen.png';
  get_started_bg = 'assets/tenant-assets/mini-env/images/father-child.png';
  imgLink = 'assets/tenant-assets/mini-env/images/woman-waving-sm.png';

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient,
    private helperService : HelperService
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  serviceDetails: any;


  benefits = [
    {
      id: '01',
      title: 'Flexibility',
      description: 'Manage your health with comprehensive in-person and virtual care options that fit your schedule and medical needs.',
      bgImage: 'd-shape'
    },
    {
      id: '02',
      title: 'Affordability',
      description: 'Free virtual services, and direct-pay for in-person care with exclusive discounts, so you pay less than with an insurance plan.',
      bgImage: 'circles'
    },
    {
      id: '03',
      title: 'Transparency',
      description: 'Know the total cost of care when you make an appointment, and pay at the time of service. Goodbye surprises & bills in the mail.',
      bgImage: 'm-shape'
    },
  ];

  faqs: any[] = [
  {
    question: 'What is the difference between WoW Plus & health insurance?',
    answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
  },
  {
    question: 'Why do I need WoW Health?',
    answer: 'It provides affordable access to routine care and prescriptions...'
  }
];

bannerSlides: any[] = [
  {
    title: 'Your Partner in Health, Always Within Your Reach',
    subtitle: 'Get free virtual care anytime, anywhere, with access to both doctors and behavioral health counselors. Quality care is just a click away!',
    link: '/join',
    buttonText: 'Member Login',
    buttonText2: 'First Time Login',
    buttonAction: 'login',
    buttonAction2: 'first-login',
    bannerClass: 'cehas-banner'
  },
];

 steps = [
    {
      id: '01',
      title: '01. Log In to Your Account',
      description: 'Login to your account'
    },
    {
      id: '02',
      title: '02. View Your Dashboard',
      description: 'Your dashboard lists all of your available services'
    },
    {
      id: '03',
      title: '03. Choose Your Service',
      description: 'Select the needed services and follow the workflow.'
    },
  ];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    const config = this.storageService.getMiniEnvConfig(); 
    this.helperService.changeMiniEnvColor()
    if (config.primaryColor) {
      document.documentElement.style.setProperty('--primarycolor', config.primaryColor);
      document.documentElement.style.setProperty('--primary-mini-env-2', config.primaryColor2);
      document.documentElement.style.setProperty('--primary-mini-env-3', config.primaryColor3);
      document.documentElement.style.setProperty('--primaryOutlineColor', config.primaryColor2);
      document.documentElement.style.setProperty('--secondarycolor', config.secondaryColor);
    }

   this.getService();
  }

  async getService() {
    try {
      const services = await this.sharedService.getServicesForTabs(); 
      this.serviceDetails = services.find((s: any) => s.serviceCode === 'telehealth_services');
    } catch (error) {
      console.error('Error fetching services for tabs:', error);
    }
  }

  login() {
    this.router.navigate([LOGIN_PATH]);
  }

  onSliderBtnAction(action: any) {
    if (action == 'login') {
      this.login();
    } else {
      this.router.navigate([CEHAS_ACCESS_ACCOUNT]);
    }
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

}
